import React, { createContext, useState } from "react";
import Utils from "../../utils";
import { ADMIN_GROUP_NAME } from "../../helpers/constant";

// AppDataContext Definition
export const AppDataContext = createContext();

export const AppDataContextProvider = ({ children }) => {
    const [campaign, setCampaign] = useState({ id: "", name: "" });
    const [insightName, setInsightName] = useState("");
    const [currentCompanyAlerts, setCurrentCompanyAlerts] = useState([]);
    const [loadingAlerts, setLoadingAlerts] = useState(false);

    const clearAppData = () => {
        const emptyObject = {
            id: "",
            name: ""
        }
        setCampaign({ ...emptyObject });
        setInsightName("");
    }

    const loadCompanyAlertsData = async (loader = true) => {
        setLoadingAlerts(loader);
        try {
            const { user, groups } = await Utils.getCurrentUserAndGroups();
            const nonAdminGroup = groups.filter((z) => z !== ADMIN_GROUP_NAME);

            if (nonAdminGroup.length === 0) {
                setCurrentCompanyAlerts([]);
                return;
            }

            const companyList = await Utils.genericList("listCompanies", {
                filter: { internalname: { eq: nonAdminGroup[0] } },
            });
            const companyId = companyList.data.listCompanies.items[0].id;
            const company = await Utils.genericGetMOD("getCompany", companyId, {
                before: "alerts",
                after: "alerts(limit:10000)",
            });

            const alerts = company.data.getCompany.alerts.items;

            for (const alert of alerts) {
                alert.createdAt = new Date(alert.createdAt);
                if (alert.risk === null || alert.risk === undefined) {
                    alert.risk = false;
                }
                try {
                    if(alert.readBy) {
                        alert.readBy = JSON.parse(alert.readBy);
                    }
                    alert.isRead = alert.readBy.some(u => u.userId === user.username);
                } catch (error) {}
            }
            const sortedAlerts = alerts.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1);
            setCurrentCompanyAlerts([...sortedAlerts]);
            setLoadingAlerts(false);
        } catch (error) {
            setLoadingAlerts(false);
            console.error("Error loading company alerts data:", error);
            setCurrentCompanyAlerts([]);
        }
    }

    return (
        <AppDataContext.Provider value={{
            campaign, setCampaign,
            insightName, setInsightName,
            currentCompanyAlerts, setCurrentCompanyAlerts,
            loadCompanyAlertsData, loadingAlerts,
            clearAppData
        }}>
            {children}
        </AppDataContext.Provider>
    );
};
